import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "completed",
  "use": "completed-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol viewBox=\"0 0 11 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"completed\">\n<path d=\"M4.40233 7.84291L10.571 1.67427C10.7804 1.46481 10.7804 1.12516 10.571 0.915698L9.81238 0.157124C9.60292 -0.0523747 9.26328 -0.0523747 9.05378 0.157124L4.02302 5.18785L1.67428 2.83911C1.46482 2.62964 1.12517 2.62964 0.915673 2.83911L0.157099 3.59768C-0.0523663 3.80714 -0.0523663 4.14679 0.157099 4.35625L3.64372 7.84287C3.85322 8.05237 4.19283 8.05237 4.40233 7.84291Z\" fill=\"#17C25F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol